import * as C from './consts'
import * as M from './models'
import { boundApiReducer as api } from 'redux-upgrader'

export const dashboard = api(C.GET_DASHBOARD, M.Dashboard)
